<template>
    <footer class="bg-tertiary py-10 text-gray-300 mt-5">
        <div class="container mx-auto lg:flex items-center">
            <div class="flex-1 mx-10 lg:mx-0">
                <div class="lg:flex lg:space-x-20 space-y-10 lg:space-y-0">
                    <div v-for="list in footerItems">
                        <h4 class="font-bold mb-2">{{ list.title }}</h4>
                        <ul>
                            <li v-for="link in list.items">
                                <component
                                    :is="link.component"
                                    :href="link.href"
                                    :target="link.target"
                                    class="opacity-50 text-sm hover:opacity-100 hover:text-white"
                                >
                                    {{ link.title }}
                                </component>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="flex-initial flex flex-col items-end mt-10 lg:mt-0 mx-10 lg:mx-0">
                <div class="w-[10rem]">
                    <template v-if="app.logo.light">
                        <figure>
                            <img :src="app.logo.light" :alt="app.name" />
                        </figure>
                    </template>
                    <template v-else>
                        <MediaPressLogo />
                    </template>
                </div>

                <div class="whitespace-nowrap text-xs mt-5 opacity-40 text-right">
                    Copyright © {{ new Date().getFullYear() }} HotPress Media (Pty) Ltd.<br />
                    <span class="opacity-80">v{{ version }}</span> <span class="opacity-60">Build #{{ release }}</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import {computed} from "vue";
import {Link, usePage} from "@inertiajs/inertia-vue3";
import {route} from "@/Scripts/Routing/Router.js";
import MediaPressLogo from "@/Components/MediaPressLogo.vue";

const profile = computed(() => {
    return usePage().props.value.profile;
})

const app = computed(() => {
    return usePage().props.value.app;
})

const version = computed(() => {
    return usePage().props.value.version;
})

const release = computed(() => {
    return usePage().props.value.release;
})

const footerItems = [
    {
        title: 'MotorPress',
        items: [
            {
                title: 'About',
                component: Link,
                href: route('home.about'),
            },
            {
                title: 'Contact',
                component: Link,
                href: route('home.contact'),
            },
            {
                title: 'Support',
                component: Link,
                href: route('home.support'),
            },
            {
                title: 'Service Status',
                component: 'a',
                href: app.value.footer.status,
                target: '_blank',
            },
            {
                title: 'API',
                component: Link,
                href: route('home.api'),
            },
        ]
    },
    {
        title: 'Legal',
        items: [
            {
                title: 'Terms and Conditions',
                component: Link,
                href: route('legal.terms'),
            },
            {
                title: 'Privacy Policy',
                component: Link,
                href: route('legal.privacy'),
            },
            {
                title: 'Cookie Policy',
                component: Link,
                href: route('legal.cookies'),
            },
            {
                title: 'Report Abuse',
                component: Link,
                href: route('legal.abuse'),
            },
        ]
    },
    {
        title: 'HotPress',
        items: [
            {
                title: 'HotPress Website',
                component: 'a',
                href: 'https://www.hotpress.co.za',
                target: '_blank',
            },
            {
                title: 'FleetPress',
                component: 'a',
                href: 'https://fleetpress.co.za',
                target: '_blank',
            },
            {
                title: 'EventPress',
                component: 'a',
                href: 'https://eventpress.co.za',
                target: '_blank',
            }
        ]
    }
];


</script>

<style scoped>

</style>
